// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"2d809334","376":"4f750d3c","622":"6f2a6611","896":"4910e2dc"}[chunkId] + ".chunk.css";
};